// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: snapdoc/extensions.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { SnapComponentType } from "./snap_component_type";

export const protobufPackage = "snapchat.snapdoc";

export interface SnapDocMessageOptions {
  componentTypeId?: SnapComponentType | undefined;
  componentTypeName?: string | undefined;
  shouldEncrypt: boolean;
}

function createBaseSnapDocMessageOptions(): SnapDocMessageOptions {
  return { componentTypeId: undefined, componentTypeName: undefined, shouldEncrypt: false };
}

export const SnapDocMessageOptions: MessageFns<SnapDocMessageOptions> = {
  encode(message: SnapDocMessageOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.componentTypeId !== undefined) {
      writer.uint32(8).int32(message.componentTypeId);
    }
    if (message.componentTypeName !== undefined) {
      writer.uint32(18).string(message.componentTypeName);
    }
    if (message.shouldEncrypt !== false) {
      writer.uint32(24).bool(message.shouldEncrypt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SnapDocMessageOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSnapDocMessageOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.componentTypeId = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.componentTypeName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.shouldEncrypt = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SnapDocMessageOptions>, I>>(base?: I): SnapDocMessageOptions {
    return SnapDocMessageOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SnapDocMessageOptions>, I>>(object: I): SnapDocMessageOptions {
    const message = createBaseSnapDocMessageOptions();
    message.componentTypeId = object.componentTypeId ?? undefined;
    message.componentTypeName = object.componentTypeName ?? undefined;
    message.shouldEncrypt = object.shouldEncrypt ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
